import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trade-advisory',
  templateUrl: './trade-advisory.component.html',
  styleUrls: ['./trade-advisory.component.scss']
})
export class TradeAdvisoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
